import React from "react";
import { Form } from "react-final-form";
import UiInput from "../UiInput";
import { SearchIcon } from "../../../styles/img/svg/SearchIcon";
import { useTranslation } from "react-i18next";

export const UiSearchForm = (props) => {
  const { t, i18n } = useTranslation();
  const onSubmit = () => {};
  const FormWrapperClassName = `df-search-form ${
    props.wrapperClassName || ""
  }`.trim();
  return (
    <div className={FormWrapperClassName}>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form }) => (
          <form onSubmit={handleSubmit} className={props.className}>
            <UiInput
              maxLength={50}
              name="search"
              label={t("Search...")}
              type="text"
              varient="outlined"
              placeholder={t("Search...")}
              inputonChange={(e) => {
                form.change("search", e.target.value);
                props.handleNameChange(e.target.value);
              }}
              inputStartIcon={<SearchIcon />}
            />
          </form>
        )}
      />
    </div>
  );
};
